import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Phase 2L-A38 — Route-change scroll reset.
 *
 * React Router preserves the previous page's scroll position when you
 * navigate between routes, so a user reading halfway down the homepage
 * who clicks "Blog" would land halfway down the blog index. This helper
 * snaps the new page back to the top on every pathname change.
 *
 * Intentional anchor navigation (`/page#section`, `/#how-it-works`) is
 * preserved — when a hash is present we let the browser's native anchor
 * scroll do its job instead of forcing scroll-to-top.
 *
 * Mount once inside <BrowserRouter> near the top of the tree.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
